module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"da":{"paired-article-banner":{"label":"Passende modstykke"}},"de":{"version":1,"paired-article-banner":{"label":"Passendes Gegenstück"}},"fr":{"paired-article-banner":{"label":"Pièce complémentaire"}},"nl":{"paired-article-banner":{"label":"Passend tegenstuk"}}}')
  delete Component.options._Ctor
}
